import React, { Fragment, useState } from "react";
import { ADD_ITEM_DETAILS, ADD_PAYMENT_INFO } from "constants/global";
import ShippingLeg from "../../../../component/flex/shipments/components/ShippingLeg";
import { Bars } from "react-loader-spinner";
import trash from "../../../../asset/images/trash.png";
import { Nav, NavDropdown } from "react-bootstrap";
import { ShipmentIcon } from "asset/icons";

const AddShipmentDetails = ({
    submitSecondForm,
    goToStep,
    shippingLegs,
    setShippingLegs,
    isSecondStepValid,
    isLoading,
    selectedUser,
    setSelectedUser,
}) => {
    const [showMore, setShowMore] = useState();
    
    // Add a new shipping leg
    const addShippingLeg = () => {
        setShippingLegs([
            ...shippingLegs,
            {
                id: Date.now(),
                type: "",
                departurePort: "",
                destinationPort: "",
                shippingLine: "",
                clearingAgent: null,
                dropOffDate: "",
                isClearingAgent: false,
                document: null,
            },
        ]);
        setShowMore(undefined)
    };

    // Update a specific shipping leg's state
    const updateShippingLeg = (id, field, value) => {
        setShippingLegs(
            shippingLegs.map((leg) => {
                if (leg.id === id) {
                    if (field === "isClearingAgent" && value) {
                        return { ...leg, [field]: value, clearingAgent: null };
                    }
                    return { ...leg, [field]: value };
                } else {
                    return leg;
                }
            })
        );
    };

    // Remove a shipping leg
    const removeShippingLeg = (id) => {
        if (shippingLegs.length <= 1) {
            return;
        }
        setShippingLegs(shippingLegs.filter((leg) => leg.id !== id));
    };

    return (
        <div className="">
            <h3 className="text-main-dark font-[450] text-2xl !mb-6">Add shipping details</h3>
            <>
                {shippingLegs.map((leg, index) => {
                    return (
                        <Fragment key={index}>
                            {leg?.type ? (
                                <ShippingLeg
                                    leg={leg}
                                    index={index + 1}
                                    updateShippingLeg={updateShippingLeg}
                                    removeShippingLeg={removeShippingLeg}
                                    shippingLegs={shippingLegs}
                                    selectedUser={selectedUser}
                                    setSelectedUser={setSelectedUser}
                                    showMore={showMore}
                                    setShowMore={setShowMore}
                                />
                            ) : (
                                <div key={leg?.id} className="relative">
                                    {index ? (
                                        <img
                                            src={trash}
                                            alt=""
                                            style={{ cursor: "pointer" }}
                                            onClick={() => removeShippingLeg(leg.id)}
                                            className="absolute right-0 mt-2 mr-2 -top-1 size-4"
                                        />
                                    ) : null}

                                    <p
                                        className={`font-medium text-sm !mb-1 !mt-5 !text-[#475467]`}
                                    >
                                        Select shipping method
                                    </p>
                                    <div className="flex items-center justify-between p-3 py-2 bg-white rounded-md cursor-pointer">
                                        <div className="flex items-center justify-start w-full gap-2 m-0">
                                            <div
                                                className={`flex items-center justify-center p-2 rounded-full size-8 bg-gray-100`}
                                            >
                                                <ShipmentIcon />
                                            </div>{" "}
                                            <span className="flex items-center gap-2 text-sm text-bold">
                                                <Nav>
                                                    <NavDropdown title="Select shipping method">
                                                        <NavDropdown.Item
                                                            className=""
                                                            onClick={() => {
                                                                updateShippingLeg(
                                                                    leg.id,
                                                                    "type",
                                                                    "Sea Freight"
                                                                );
                                                                setShowMore(index + 1);
                                                            }}
                                                        >
                                                            Sea freight
                                                        </NavDropdown.Item>
                                                        <NavDropdown.Item
                                                            onClick={() => {
                                                                updateShippingLeg(
                                                                    leg.id,
                                                                    "type",
                                                                    "Truck"
                                                                );
                                                                setShowMore(index + 1);
                                                            }}
                                                            className=""
                                                        >
                                                            Truck
                                                        </NavDropdown.Item>
                                                    </NavDropdown>
                                                </Nav>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </Fragment>
                    );
                })}
                <button
                    disabled={!isSecondStepValid?.valid}
                    className={`!text-secondary mt-3
                        ${
                            !isSecondStepValid?.valid
                                ? "!text-[#D9CDFF]"
                                : "!text-secondary  cursor-pointer"
                        }
                            `}
                    onClick={addShippingLeg}
                >
                    + Add shipping leg
                </button>
            </>
            <div className="flex !gap-9 justify-end !mt-6">
                <button
                    onClick={() => goToStep(ADD_ITEM_DETAILS)}
                    type="button"
                    className="button text-[#1D2939] font-[450] !py-2 !px-6"
                    disabled={isLoading}
                >
                    Back
                </button>
                <button
                    disabled={!isSecondStepValid?.valid || isLoading}
                    onClick={() => {
                        submitSecondForm(ADD_PAYMENT_INFO);
                    }}
                    className={`!py-2 !px-6 text-white rounded-lg font-[450] ${
                        !isSecondStepValid?.valid ? "!bg-[#D9CDFF]" : "!bg-secondary"
                    }`}
                    type="submit"
                >
                    {isLoading ? (
                        <Bars color="#fff" height={23} width={23} wrapperClass="w-max mx-auto" />
                    ) : (
                        "Continue"
                    )}
                </button>
            </div>
        </div>
    );
};


export default AddShipmentDetails;
